import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "./api/apiSlice";
import authReducer from "./slices/authSlice";
import professionSlice from "./slices/professionSlice";

import doctorReducer from "./slices/doctorSlice";
import patientReducer from "./slices/patientSlice";
import employeeReducer from "./slices/employeeSlice";
import treatmentDemandReducer from "./slices/treatmentDemandSlice";
import menuReducer from "./slices/menuSlice";
import categoryReducer from "./slices/categorySlice";
import assignedTreatmentReducer from "./slices/assignedTreatmentSlice";
import messageRoomReducer from "./slices/messageRoomSlice";
import bookedAppointmentReducer from "./slices/bookedAppointmentSlice";
import availableAppointmentTimesReducer from "./slices/availableAppointmentTimeSlices";
import availableAppointmentDayReducer from "./slices/availableAppointmentDaySlices";
import userRoleSliceReducer from "./slices/userRoleSlice";
import appSliceReducer from "./slices/appSlice";
import treatmentDemandQuestionsSliceReducer from "./slices/treatmentDemandQuestionsSlice";
import treatmentDemandQuestionOptionsReducer from "./slices/quesitonOptionsSlice";
import notificationSliceReducer from "./slices/notificationSlice";
import issueSliceReducer from "./slices/issueSlice";
import priceReducer from "./slices/priceSlice";
import noteSlice from "./slices/noteSlice";
import assistantReducer from "./slices/assistantSlice";
import doctorTriageReducer from "./slices/doctorTriageSlice";
import jitsiReducer from "./slices/jitsiSlice";
const store = configureStore({
  reducer: {
    app: appSliceReducer,
    userRoles: userRoleSliceReducer,
    auth: authReducer,
    patient: patientReducer,
    employee: employeeReducer,
    doctor: doctorReducer,
    profession: professionSlice,
    menu: menuReducer,
    treatmentDemand: treatmentDemandReducer,
    category: categoryReducer,
    assignedTreatment: assignedTreatmentReducer,
    messageRoom: messageRoomReducer,
    bookedAppointment: bookedAppointmentReducer,
    availableAppointmentTimes: availableAppointmentTimesReducer,
    availableAppointmentDay: availableAppointmentDayReducer,
    treatmentDemandQuestions: treatmentDemandQuestionsSliceReducer,
    questionOptions: treatmentDemandQuestionOptionsReducer,
    notification: notificationSliceReducer,
    issue: issueSliceReducer,
    price: priceReducer,
    note: noteSlice,
    assistant: assistantReducer,
    doctorTriage: doctorTriageReducer,
    jitsi: jitsiReducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
  devTools: true,
});

export default store;

